export interface IDerivativeSearchModel { 
  query?: string;
  pageNumber: number;
  itemsPerPage: number;

  sortField?: string;
  sortDirection?: string;

  filters?: IFilterRequest[];
  settings?: ISearchSettings;
}
export class DerivativeSearchModel implements IDerivativeSearchModel{
    constructor(
      public query: string,
      public pageNumber: number,
      public itemsPerPage: number,
      public filters: IFilterRequest[],
      public settings?: ISearchSettings,
    )
    {}

    public static empty() {
      return new DerivativeSearchModel('', 1, 25, [], SearchSettings.empty());
    }
}


export interface IFilterRequest {
  name: string;
  includes: string[];
  isCustom?: boolean;
}
export class FilterRequest implements IFilterRequest {
  constructor(
    public name: string,
    public includes: string[],
    public isCustom: boolean
  ) {}

  public static empty() {
    return new FilterRequest('', [], null);
  }
}


export interface ISearchSettings {
  returnFilters?: boolean;
  hightlight?: boolean;
}
export class SearchSettings implements ISearchSettings{
  constructor(
    public returnFilters: boolean,
    public hightlight: boolean
  ) { }

  public static empty() {
    return new SearchSettings(true, false);
  }
}


